'use strict';

var GridRejectHostShareButtonDirective = function GridRejectHostShareButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-reject-host-share-button.html'),
    controller: 'GridRejectHostShareButtonController',
    link: function link($scope) {
      $scope.$on('grid:rowSelectionChanged', function (event, selectedRows, gridId, allRows, selectedRowIndexes) {
        $scope.onRowSelection(selectedRows, selectedRowIndexes);
      });
      $scope.$on('host-share:dropDownEvent', $scope.setRejectButtonState);
    }
  };
};
GridRejectHostShareButtonDirective.$inject = [];
module.exports = GridRejectHostShareButtonDirective;